/* Pholoh x JUJUTSU KAISEN - header + home hero treatment (forked 2026-10-05 from pholoh-assignment-hero.js).
   JJK changes: JJK lockup, list JJK DROP SIGNUPS, drop Sat 2026-10-10 12:00 PT, PRE-DROP capture runs on the
   WHITE theme too (it used to switch to the post-drop LIVE NOW button whenever the page was light),
   hero furniture always WHITE over the footage, phone REQUIRED (Diego: 'they have to put in their phone').

   Original header:

   Replaces the RE treatment (pholoh-re-countdown.js) one-for-one: same DOM hooks, same
   cascade tricks, different art and different ink. Delete this file and its <script> tag in
   layout/theme.liquid and the stock header/hero come back.

   INK IS WHITE, AND THAT IS A MEASUREMENT, NOT A PREFERENCE.
   Diego asked for black logos. The footage says no. Sampling every frame of both encodes
   underneath each piece of hero furniture:

       region                  mean    %dark(<.35)  %light(>.65)
       hamburger (top-left)    0.27       72.4%        10.0%
       logo lockup (centre)    0.38       62.0%        12.4%
       CTA button              0.28       74.3%        10.2%

   Black ink is unreadable for ~two thirds of the run; white fails ~11%. So white is the
   default and BLACK is one constant away (set INK below).

   That remaining ~11% is the white peak near the end. It used to be covered by the film's own
   burned-in lockup, but that was removed on request (2026-09-03), so the furniture now carries
   both extremes itself via the halo further down. If the peak ever reads as empty, the answer
   is more halo - NOT flipping to black ink, which would trade an 11% problem for a 62% one.

   Art: assets/pholoh-assignment-lockup-{white,black}.png - the delivered black lockup
   (LOCKUP_black_3840.png) trimmed to its own alpha bounds and, for white, the SAME alpha
   with the ink flipped. Not redrawn, so the letterforms are the delivered ones. */
(function () {
  /* ⭐ INK IS MEASURED, NOT DECLARED. The same file serves the dark live theme and the white
     build, and the hamburger was rendering #FFFFFF on a #FFFFFF header - invisible. Reading the
     page's own background means neither theme needs its own copy of this script. */
  function pageIsLight(){
    try {
      var el = document.body, bg = '';
      for (var i = 0; i < 4 && el; i++){
        bg = getComputedStyle(el).backgroundColor || '';
        var m = /rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?\)/.exec(bg);
        if (m && (m[4] === undefined || parseFloat(m[4]) > 0.5)){
          return (0.299 * +m[1] + 0.587 * +m[2] + 0.114 * +m[3]) > 140;
        }
        el = el.parentElement;
      }
    } catch(e){}
    return false;
  }
  var LIGHT      = pageIsLight();
  var INK        = LIGHT ? 'black' : 'white';
  var COLOR      = INK === 'black' ? '#000000' : '#FFFFFF';
  var COLOR_INV  = INK === 'black' ? '#FFFFFF' : '#000000';
  /* the countdown + form sit over the dark JJK footage, not over the page: always white */
  var HCOLOR = '#FFFFFF', HCOLOR_INV = '#000000';
  /* 🚨 THE LOCKUP IS ALWAYS WHITE, regardless of page ink. It sits over the DARK CENTRE of
     the footage, not over the page background, so tying it to INK loaded the black artwork
     on the white build and it vanished into the picture. Header ink and hero-lockup ink are
     two different questions and must not share a variable. */
  var LOCKUP     = 'jjk-lock-lockup-red.png';   /* Diego 10-06: the film's CRAYON line lockup (red), not the solid white PNG */
  var LOCKUP_W   = 1450, LOCKUP_H = 513;    /* measured after the alpha trim */

  function assetUrl(file){
    var s = document.querySelector('script[src*="pholoh-jjk-hero.js"]');
    if (!s) return null;
    var src = s.getAttribute('src') || '';
    return src.split('?')[0].replace(/pholoh-jjk-hero\.js$/, '') + file;
  }

  /* 🚨 A CSS MASK ON A <video> IS UNRELIABLE IN CHROME - the vertical mask on the wrapper div
     took effect while the identical horizontal mask on the video itself did nothing, which is
     what made the sides stay hard while the top went white. So the video is wrapped in a plain
     div and BOTH masks live on divs. The <video> element is only re-parented, never replaced, so
     every theme reference to it (play/pause, slideshow autoplay) keeps working. */
  function featherHero(){
    var vids = document.querySelectorAll('.pholoh-hero-vid');
    for (var i = 0; i < vids.length; i++){
      var v = vids[i];
      if (v.parentElement && v.parentElement.classList.contains('pholoh-hero-feather')) continue;
      var stage = v.closest('.pholoh-hero-stage') || v.parentElement;
      if (!stage) continue;
      var w = document.createElement('div');
      w.className = 'pholoh-hero-feather';
      v.parentNode.insertBefore(w, v);
      w.appendChild(v);
    }
  }

  /* the slideshow can mount its slide after this script runs, so retry briefly rather than
     assuming the video exists on first call */
  (function(){
    var n = 0;
    var t = setInterval(function(){ featherHero(); if (++n > 20) clearInterval(t); }, 400);
  })();

  function injectCss(){
    featherHero();
    if (document.getElementById('at-hero-css')) return;
    var css = document.createElement('style');
    css.id = 'at-hero-css';
    css.textContent =
      /* ---- HERO EDGES DISSOLVE INTO THE WHITE PAGE ------------------------------------
         Measured on the live asset: the frame's centre reads 250 (white) but its edges read
         59-163, so the footage met the white page as a hard dark rectangle - the "sharp lines
         on the top and the bottom" Diego saw.

         ⭐ This is a CSS MASK, not a re-encode. Feathering the source would bake a fade at one
         fixed aspect ratio, and the video is `object-fit:cover` - it gets cropped differently on
         every screen, so a baked edge would drift inside the frame on some phones and sit off
         it on others. A mask always follows the element's real box.

         The ramp uses five stops rather than a straight `transparent -> black`. A linear fade
         over a large distance shows banding on flat greys, which this footage is full of; the
         eased stops keep the falloff smooth. The ramp is LONG - 24% each side horizontally, 20%
         vertically - because the footage runs dark at the frame edges and a short fade over near
         black still reads as an edge. The subject sits centred, so the generous margin costs
         nothing.

         🚨 THE RAMP IS DELIBERATELY SLOW AT THE START. Opacity fades toward the page, so black
         footage at 40% alpha over white is still mid-grey 153 - it reads as an edge, not a
         blend. Holding alpha under .12 for the first ~10% of the width is what actually makes
         a dark frame dissolve. A straight linear fade over the same distance does not. The two gradients are INTERSECTED so all four
         edges fade and the corners fade twice, which is what makes a corner read as round
         rather than as a bevel. */
      /* ⭐ ONE GRADIENT PER ELEMENT - the video carries the horizontal fade, its wrapper the
         vertical one. Two mask layers on a single element with `mask-composite:intersect` is
         the obvious way to write this and it DOES NOT WORK here: Chrome composited the layers
         as a UNION, so only the corners faded and all four edges stayed hard - which looked
         like the mask had failed when it was actually inverted logic. Stacking one mask per
         element multiplies the two naturally and needs no compositing keyword at all. */
      /* 🚨🚨 THE BLACK BAR WAS THE THEME'S OWN `.slideshow__slide::after`.
         Computed: `linear-gradient(rgba(0,0,0,0) 0%, rgba(0,0,0,.35) 42%, rgba(0,0,0,.82) 76%...)`
         at z-index 2 - a darkening scrim the theme paints over every slide for text contrast.
         My white feather was written onto THE SAME pseudo-element, so the theme's rule simply
         won and my gradient never painted at all. That is why the bottom kept reading dark no
         matter which masking trick was tried: nothing was masking the bar, because the bar was
         painted ON TOP of everything being masked.
         So: neutralise the theme's ::after, and put the white feather on ::before instead so
         the two can never collide again. */
      /* ⭐ THE SEAM IS CLOSED FROM THE HERO SIDE, NOT THE HEADER SIDE.
         The header covers the first ~11% of the hero (header bottom y=103, hero top y=32 of a
         645 tall frame), so the gradient now holds PURE WHITE to 12% and only starts fading
         below that. Those pixels are hidden behind the header anyway - holding them white costs
         nothing on screen and means the image emerges from the header at 255, with no step.
         🚨 The header-gradient approach below never applied: the white-theme sheet carries
         `html body #SiteHeader{background:#fff!important}` and even an ID-matching override read
         back `backgroundImage: none`. Not worth fighting - the hero side is free. */
      /* 🚨 THE LINE UNDER THE LOGO WAS NOT A BORDER - every header element measured
         `0px none`. It is the edge where the SOLID WHITE header stops painting and the hero
         starts showing through. The hero's own top fade begins at the hero's top, but the header
         covers the first ~11% of it, so by the time the image is visible it is already ~30%
         opaque - a step against a pure white bar.
         Fixing it on the hero side alone would mean holding the hero white until well past the
         header and wasting a chunk of the frame. Instead the HEADER dissolves: solid white where
         the logo and icons sit, fading to transparent at its bottom edge, so the two meet with
         nothing to see. On the home page only - every other page needs an opaque header. */
      (LIGHT ?
        /* 🚨 SPECIFICITY: the white-theme sheet carries `html body #SiteHeader{background:#fff
           !important}`. An ID beats a class even when both are !important, so
           `.template-index .site-header` silently lost and the header stayed solid white
           (computed backgroundImage read `none`). Match ID + body class to outrank it. */
        'html body.template-index #SiteHeader,html body.template-index .site-header,'+
        'html body.template-index .header-wrapper{'+
          'background:linear-gradient(to bottom,#fff 0,#fff 58%,rgba(255,255,255,.88) 76%,'+
          'rgba(255,255,255,.55) 88%,rgba(255,255,255,0) 100%)!important;'+
          'border-bottom:0!important;box-shadow:none!important}'+
        /* ⭐ NUDGE THE FRAMING DOWN so the subjects sit centred rather than riding high.
           `object-position` moves the CROP, not the element - the video still fills the box
           edge to edge, so nothing is exposed and the feather is untouched. The source is
           taller than the box on both breakpoints (1080x1920 into 430x645, 1920x1080 into
           1440x765), so `cover` crops vertically and Y has real travel. A LOWER Y shows more
           of the TOP of the source, which pushes the visible content DOWN. */
        'html body.template-index .pholoh-hero-vid{object-position:50% 32%!important}'+
        /* 🚨 THE "BOX" DIEGO SAW ON HIS PHONE (2026-09-12): the theme paints its colour overlay
           on `.hero__image-wrapper::before` - rgb(31,29,27) at opacity .15, z-index 3, covering
           the WHOLE stage rectangle. The white feather fades the footage to white, but this
           flat 15% dark veil sits over the faded areas too, so the hero reads as a faint grey
           rectangle with four straight edges on the white page. Measured computed style on the
           stage's ::before: backgroundColor rgb(31,29,27), opacity 0.15. Kill it on the light
           build. And pin the poster + video to the stage box so nothing can sit inset. */
        'html body.template-index .pholoh-hero-stage::before,html body.template-index .hero__image-wrapper::before,'+
        'html body.template-index .hero__media::before{display:none!important;opacity:0!important;background:none!important}'+
        'html body.template-index .slideshow__slide img.hero__image,html body.template-index .pholoh-hero-vid{'+
          'position:absolute!important;top:0!important;left:0!important;width:100%!important;height:100%!important;'+
          'max-width:none!important;object-fit:cover!important;margin:0!important}'+
        'html body.template-index .pholoh-hero-stage,html body.template-index .slideshow__slide{overflow:hidden}'+
        '.template-index .slideshow__slide{position:relative}'+
        '.template-index .slideshow__slide::after{background:none!important;background-image:none!important;'+
          'opacity:0!important}'+
        '.template-index .slideshow__slide::before{content:"";position:absolute;inset:0;'+
          'pointer-events:none;z-index:3;background:'+
            'linear-gradient(to bottom,#fff 0,#fff 12%,rgba(255,255,255,.88) 17%,rgba(255,255,255,.62) 23%,rgba(255,255,255,.34) 30%,rgba(255,255,255,.14) 37%,rgba(255,255,255,.04) 43%,rgba(255,255,255,0) 50%,'+
              'rgba(255,255,255,0) 74%,rgba(255,255,255,.14) 81%,rgba(255,255,255,.5) 88%,rgba(255,255,255,.85) 94%,#fff 100%),'+
            'linear-gradient(to right,#fff 0,rgba(255,255,255,.86) 3%,rgba(255,255,255,.45) 7%,rgba(255,255,255,.12) 12%,rgba(255,255,255,0) 18%,'+
              'rgba(255,255,255,0) 82%,rgba(255,255,255,.12) 88%,rgba(255,255,255,.45) 93%,rgba(255,255,255,.86) 97%,#fff 100%)}'+
        '.template-index .hero__text-wrap{z-index:4;position:relative}'
      : '') +
      /* ⭐ FROSTED GLASS, matching the Resident Evil treatment: a translucent ground plus
         `backdrop-filter:blur(3px)` so the footage moves THROUGH the button instead of being
         hidden by it (see `assets/re-grid.css` - `rgba(0,0,0,.62)` + 1px white hairline + 3px
         blur). The hero behind this is dark and busy, so the blur is what keeps the label
         readable without resorting to a solid fill.
         🚨 `backdrop-filter` needs the -webkit- prefix for Safari, and a fallback ground for
         browsers that support neither - otherwise the button reads as a transparent hole. */
      '.athero-cta{display:flex;justify-content:center;align-items:center}' +
      /* The button IS the note. `.athero-note` is a plain box carrying the frosted ground and
         the backdrop blur; `clip-path` then cuts that box down to the glyph, so what you see
         through the blur is the slideshow moving behind the note itself - exactly the Resident
         Evil treatment, just on an irregular silhouette instead of a pill.
         Deliberately NO border: a 1px stroke around five overlapping shapes draws the seams
         where stem meets beam. A drop-shadow follows the clipped outline instead and gives the
         same separation from the footage. */
      'html body.template-index .athero-note-btn{display:flex;flex-direction:column;'+
        'align-items:center;justify-content:center;gap:18px;text-decoration:none;'+
        'background:none!important;border:0!important;padding:0!important;color:#fff!important}' +
      /* ⭐ HEARTBEAT. The note is a live indicator, so it beats: frosted grey -> solid white and
         back, lub-dub, with a soft halo behind it and the LIVE NOW label glowing on the SAME
         1.5s clock so the three read as one pulse.
         Layout: `.athero-note-wrap` owns the desktop size scale (`--s`) and the halo; the note
         itself only carries the beat scale. Two transforms on one element would fight.
         🚨 The halo lives on the WRAP's ::before, not on the note: anything on the note is cut
         by its clip-path, and a `filter` on the button would blind the note's backdrop-filter
         (a filtered ancestor becomes the backdrop root, so the blur would sample nothing). */
      'html body.template-index .athero-note-wrap{--s:1;position:relative;display:block;'+
        'width:104px;height:104px;transform:scale(var(--s));transform-origin:50% 50%}' +
      'html body.template-index .athero-note-wrap::before{content:"";position:absolute;'+
        'inset:-42%;border-radius:50%;pointer-events:none;z-index:0;'+
        'background:radial-gradient(circle,rgba(255,255,255,.62) 0%,rgba(255,255,255,.22) 34%,rgba(255,255,255,0) 66%);'+
        'opacity:0;animation:athero-halo 1.5s ease-in-out infinite}' +
      'html body.template-index .athero-note{position:relative;z-index:1;width:104px;height:104px;display:block;'+
        'transform:scale(1);transform-origin:50% 50%;'+
        '-webkit-clip-path:url(#athero-noteclip);clip-path:url(#athero-noteclip);'+
        'background:rgba(255,255,255,.42);'+
        '-webkit-backdrop-filter:blur(8px) saturate(1.15);backdrop-filter:blur(8px) saturate(1.15);'+
        'filter:drop-shadow(0 0 1.6px rgba(0,0,0,.6)) drop-shadow(0 3px 14px rgba(0,0,0,.45));'+
        'transition:background .2s ease,transform .2s ease;'+
        'animation:athero-beat 1.5s ease-in-out infinite}' +
      /* hover stops the beat and holds the lit state so the button reads as pressed */
      'html body.template-index .athero-note-btn:hover .athero-note,'+
        'html body.template-index .athero-note-btn:focus-visible .athero-note{'+
        'animation:none;background:rgba(255,255,255,.93);transform:scale(1.06)}' +
      'html body.template-index .athero-note-btn:hover .athero-dot__lbl,'+
        'html body.template-index .athero-note-btn:focus-visible .athero-dot__lbl{'+
        'animation:none;text-shadow:0 0 14px rgba(255,255,255,.9),0 1px 10px rgba(0,0,0,.55)}' +
      '@keyframes athero-beat{'+
        '0%{background:rgba(255,255,255,.42);transform:scale(1)}'+
        '12%{background:rgba(255,255,255,.97);transform:scale(1.08)}'+
        '24%{background:rgba(255,255,255,.5);transform:scale(1)}'+
        '36%{background:rgba(255,255,255,.88);transform:scale(1.05)}'+
        '56%,100%{background:rgba(255,255,255,.42);transform:scale(1)}}' +
      '@keyframes athero-halo{'+
        '0%{opacity:0}12%{opacity:1}24%{opacity:.18}36%{opacity:.7}56%,100%{opacity:0}}' +
      '@keyframes athero-lbl{'+
        '0%{text-shadow:0 0 0 rgba(255,255,255,0),0 1px 10px rgba(0,0,0,.55)}'+
        '12%{text-shadow:0 0 16px rgba(255,255,255,.95),0 1px 10px rgba(0,0,0,.55)}'+
        '24%{text-shadow:0 0 3px rgba(255,255,255,.15),0 1px 10px rgba(0,0,0,.55)}'+
        '36%{text-shadow:0 0 12px rgba(255,255,255,.7),0 1px 10px rgba(0,0,0,.55)}'+
        '56%,100%{text-shadow:0 0 0 rgba(255,255,255,0),0 1px 10px rgba(0,0,0,.55)}}' +
      '.athero-noteclip-host{position:absolute;width:0;height:0;overflow:hidden}' +
      '.athero-dot__lbl{font-size:12px;font-weight:800;letter-spacing:.26em;'+
        'text-transform:uppercase;line-height:1;color:#fff;'+
        'text-shadow:0 1px 10px rgba(0,0,0,.55);transition:color .2s ease;'+
        'animation:athero-lbl 1.5s ease-in-out infinite}' +
      '@media (min-width:769px){html body.template-index .athero-note-wrap{--s:1.28;margin:16px 0}'+
        '.athero-dot__lbl{font-size:13px}}' +
      '@media (prefers-reduced-motion:reduce){html body.template-index .athero-note,'+
        'html body.template-index .athero-note-wrap::before,.athero-dot__lbl{'+
        'animation:none;transition:none}}' +
      '@media (max-width:420px){.athero-btn{padding:13px 22px;font-size:11px;letter-spacing:.14em}}' +

      /* ---- header icons: hamburger / search / cart ---- */
      '.site-nav__link--icon{color:' + COLOR + '!important}' +
      '.site-nav__link--icon svg{fill:currentColor!important;color:' + COLOR + '!important}' +
      '.site-nav__link--icon svg path{fill:currentColor!important}' +

      /* ---- hero lockup ----
         Same break-out as the RE wordmark: the hero text sits inside .page-width, so the
         negative calc margins escape that padding instead of fighting it. The lockup is
         WIDE (2.76:1), so it gets less width than the RE mark or it overpowers the frame. */
      '.template-index .at-lockup{display:block;width:86vw;max-width:none;height:auto;' +
        'margin-left:calc(50% - 43vw);margin-right:calc(50% - 43vw)}' +
      '@media (min-width:769px){.template-index .at-lockup{width:min(46vw,660px);' +
        'margin-left:auto;margin-right:auto}}' +

      /* MOBILE: lift the lockup into the middle of the space it actually occupies.
         Measured at 390x844 before the change: header logo bottom 89, GET EARLY ACCESS top
         377, so the midpoint of that band is 233 - but the lockup centre sat at 306, leaving
         246px of air above it and only 10px below. It read as glued to the label.
         -73px puts its centre exactly on 233 (84px above, 83px below).
         TRANSFORM, not margin: it moves the artwork without changing layout height, so the
         label, the field and the JOIN button all stay exactly where they were. A margin would
         re-centre the whole flex column and drag the form up with it. */
      '@media (max-width:768px){.template-index .at-lockup{transform:translateY(-73px)}}' +

      /* The footage is dark ~62% of the time but it also blows to near-white for about 1.3s
         at the peak near the end. White ink survives the dark; it vanishes on the peak. That
         used to be covered by the film's own burned-in lockup, which was removed on request,
         so the hero furniture now has to hold on BOTH extremes by itself.
         A halo does that without a scrim: invisible over black (nothing to darken), and on the
         white peak it is the only thing separating white ink from a white frame. Cheaper and
         far less intrusive than dimming the peak, which is the shot the whole ending builds to. */
      '.template-index .at-lockup{filter:drop-shadow(0 1px 2px rgba(0,0,0,.45))' +
        ' drop-shadow(0 0 22px rgba(0,0,0,.55))}' +
      '.template-index .hero__subtitle{text-shadow:0 1px 14px rgba(0,0,0,.75),0 0 3px rgba(0,0,0,.6)}' +
      '.template-index .hero__link .btn{text-shadow:0 1px 10px rgba(0,0,0,.6)}' +

      /* The theme wraps heading text in .animation-cropper (inline-flex + overflow:hidden)
         for its reveal. With a full-bleed image inside, that wrapper collapses to 0px and
         clips the lockup to nothing. Neutralised for this heading only. */
      '.template-index .hero__title{width:100%!important;margin-bottom:0!important}' +
      '.template-index .hero__title .animation-cropper,' +
      '.template-index .hero__title .animation-contents{' +
        'display:block!important;width:100%!important;overflow:visible!important;transform:none!important;' +
      '}' +

      /* ---- spacing: lockup -> sub -> button ---- */
      '.template-index .hero__subtitle{margin:10px 0 0!important}' +
      '.template-index .hero__link{margin-top:14px!important;text-align:center!important;' +
        'display:flex!important;justify-content:center!important;width:100%}' +
      '.template-index .hero__text-content{align-items:center!important}' +

      /* Blend the hero into the black grid below, exactly as the RE build did - the footage
         ends on a hard line against #000 and this ramps the last slice to that same black.
         z-index 2 keeps it under the hero text at 4. */
      '.template-index .slideshow__slide{position:relative}' +
      '.template-index .slideshow__slide::after{' +
        'content:"";position:absolute;left:0;right:0;bottom:-1px;height:26%;' +
        'background:linear-gradient(to bottom,rgba(0,0,0,0) 0%,rgba(0,0,0,.35) 42%,rgba(0,0,0,.82) 76%,#000 100%);' +
        'pointer-events:none;z-index:2;' +
      '}' +

      /* ---- CTA: outline in the ink colour, fills on hover ---- */
      '.template-index .hero__link .btn{' +
        'background:transparent!important;background-color:transparent!important;' +
        'border:2px solid ' + HCOLOR + '!important;color:' + HCOLOR + '!important;' +
        /* a soft outer glow instead of none, for the same white-peak reason as the lockup */
        'box-shadow:0 0 20px rgba(0,0,0,.5)!important;transition:background-color .2s ease,color .2s ease;' +
      '}' +
      '.template-index .hero__link .btn:hover,.template-index .hero__link .btn:focus-visible{' +
        'background-color:' + HCOLOR + '!important;color:' + HCOLOR_INV + '!important;' +
      '}' +

      /* ---- inline sign-up ----
         Sits where the CTA button was, so it inherits the centring already set on
         .hero__link. Capped at 380px: a full-width field on desktop reads as a search bar,
         not an invitation. */
      /* z-index 6 clears the theme's .hero__slide-link, which sits at 5. That anchor is also
         removed outright in buildSignup(); this is the belt to that braces, so the fields stay
         interactive even if the markup changes and the removal misses. */
      '.template-index .ats{width:min(380px,86vw);margin:0 auto;text-align:center;' +
        'position:relative;z-index:6}' +
      '.template-index .ats__row{display:flex;gap:0;align-items:stretch}' +
      '.template-index .ats__in{flex:1 1 auto;min-width:0;background:rgba(0,0,0,.34);' +
        'border:2px solid ' + HCOLOR + ';border-right:0;color:' + HCOLOR + ';padding:13px 14px;' +
        /* 16px minimum or iOS Safari zooms the entire page the moment the field is focused */
        'font-size:16px;line-height:1.2;border-radius:0;-webkit-appearance:none;appearance:none;' +
        'box-shadow:0 0 20px rgba(0,0,0,.5)}' +
      '.template-index .ats__in::placeholder{color:' + HCOLOR + ';opacity:.62}' +
      '.template-index .ats__in:focus{outline:none;background:rgba(0,0,0,.5)}' +
      '.template-index .ats__in[aria-invalid="true"]{border-color:#FF7A6B}' +
      '.template-index .ats__go{flex:0 0 auto;background:' + HCOLOR + ';color:' + HCOLOR_INV + ';' +
        'border:2px solid ' + HCOLOR + ';padding:13px 20px;font-size:12px;font-weight:800;' +
        'letter-spacing:.16em;cursor:pointer;box-shadow:0 0 20px rgba(0,0,0,.5);' +
        'transition:opacity .2s ease}' +
      '.template-index .ats__go:hover{opacity:.82}' +
      '.template-index .ats__go[disabled]{opacity:.5;cursor:default}' +
      '.template-index .ats__msg{margin:10px 0 0;font-size:12px;line-height:1.45;color:' + HCOLOR + ';' +
        'text-shadow:0 1px 10px rgba(0,0,0,.8)}' +
      '.template-index .ats__msg.is-ok{color:#8EF5A3}' +
      '.template-index .ats__msg.is-err{color:#FF9A8E}' +
      '.template-index .ats__fine{margin:8px 0 0;font-size:10px;line-height:1.5;color:' + HCOLOR + ';' +
        'opacity:.62;text-shadow:0 1px 8px rgba(0,0,0,.8)}' +
      '.template-index .ats__skip{background:none;border:0;padding:0;color:inherit;font:inherit;' +
        'text-decoration:underline;cursor:pointer}' +
      '.template-index [hidden]{display:none!important}';
    document.head.appendChild(css);
  }

  /* Header icons. These are LINE icons - stroked paths with fill:none - but the theme's
     `.icon{fill:currentcolor}` means recolouring `color` alone floods the fill and they
     render as solid blobs. Line icons are identified from the class list, NOT from computed
     fill: the stylesheet that sets fill:none can still be pending when this runs, so reading
     it here is a race. Inline !important is the only weight the theme cannot outrank. */
  function inkHeader(){
    /* HALLOWEEN 2026 (10-21): header icons are pumpkin orange on every device (touch devices drop the crayon flood filter,
       so the inline colour below is what a phone actually shows). Revert = delete this line. */
    var COLOR = (getComputedStyle(document.documentElement).getPropertyValue('--hw') || '').trim() || '#FF6A13';
    var icons = document.querySelectorAll('.site-nav__link--icon, .js-drawer-open-nav, .js-search-header, .js-drawer-open-cart');
    for (var k = 0; k < icons.length; k++) {
      icons[k].style.setProperty('color', COLOR, 'important');
      var svg = icons[k].querySelector('svg');
      if (!svg) continue;
      var isLine = /icon-(hamburger|search|bag|bag-minimal|cart|user|close)/.test(svg.getAttribute('class') || '');
      var parts = svg.querySelectorAll('path, circle, ellipse, line, polygon, polyline, rect');
      svg.style.setProperty('color', COLOR, 'important');
      if (isLine) svg.style.setProperty('fill', 'none', 'important');
      for (var m = 0; m < parts.length; m++) {
        parts[m].style.setProperty('color', COLOR, 'important');
        parts[m].style.setProperty('stroke', COLOR, 'important');
        parts[m].style.setProperty('fill', isLine ? 'none' : COLOR, 'important');
      }
    }
  }

  /* Heading text -> the lockup, keeping the real text as alt so it still reads as a heading
     to screen readers and to search. */
  function swapLockup(){
    var url = assetUrl(LOCKUP);
    if (!url) return;
    var slide = document.querySelector('.slideshow__slide');
    var title = (slide && slide.querySelector('.hero__title')) || document.querySelector('.hero__title');
    if (!title || title.querySelector('.at-lockup')) return;
    var label = (title.textContent || 'Pholoh x Assignment').replace(/\s+/g, ' ').trim();
    var host = title.querySelector('.animation-contents') || title;
    if (drawLockup(host, label)) return;
    var img = document.createElement('img');
    img.className = 'at-lockup';
    img.src = url;
    img.alt = label;
    img.width = LOCKUP_W;
    img.height = LOCKUP_H;
    host.innerHTML = '';
    host.appendChild(img);
  }

  /* Diego 10-07: on load the swirl, the X and the heart DRAW THEMSELVES IN, exactly as in the film. Same clip as the lock page
     (jjk-lock-draw.mp4, 1760x580, ink on film red), cropped to the lines and KEYED per frame into a transparent canvas: alpha =
     how much darker than the sampled red, ink = JJK red #f4f2ee, so it lands red-on-black. The canvas takes the img's class, so
     every .at-lockup size/position rule still applies. When the clip passes DRAW_CUE the title + LIVE NOW draw on (heroDrawGo). */
  var DRAW_CLIP = 'jjk-lock-draw.mp4', DRAW_END = 'jjk-lock-draw-end.webp', DRAW_CUE = 2.6;
  var CX = 224, CY = 44, CW = 1438, CH = 490, CS = 0.75;   /* crop of the 1760x580 clip = the line bbox + 4px; 0.75 scale */
  var drawFired = false;
  function heroDrawGo(){ if (drawFired) return; drawFired = true; document.documentElement.classList.add('jjk-draw-go'); }
  function drawLockup(host, label){
    if (document.documentElement.classList.contains('hw-on')) return false;   /* HALLOWEEN 2026: JJK hero hidden - skip the draw clip download */
    var clip = assetUrl(DRAW_CLIP), endU = assetUrl(DRAW_END);
    if (!clip || !endU || !document.body.classList.contains('template-index')) return false;
    var W = Math.round(CW * CS), H = Math.round(CH * CS);
    var cv = document.createElement('canvas');
    cv.className = 'at-lockup at-lockup--draw'; cv.width = W; cv.height = H;
    cv.setAttribute('role', 'img'); cv.setAttribute('aria-label', label);
    var g = cv.getContext('2d');
    var off = document.createElement('canvas'); off.width = W; off.height = H;
    var og = off.getContext('2d', { willReadFrequently: true });
    function keyed(src){
      try {
        og.clearRect(0, 0, W, H);
        og.drawImage(src, CX, CY, CW, CH, 0, 0, W, H);
        var im = og.getImageData(0, 0, W, H), d = im.data, n = d.length;
        var bg = (d[0] + d[(W - 1) * 4] + d[((H - 1) * W) * 4] + d[((H - 1) * W + W - 1) * 4]) / 4;
        var lo = Math.max(bg - 58, 8), span = bg - lo;
        for (var i = 0; i < n; i += 4){ var a = (bg - d[i]) / span; a = a < 0 ? 0 : (a > 1 ? 1 : a);
          d[i] = 244; d[i + 1] = 242; d[i + 2] = 238; d[i + 3] = Math.round(a * 255); }
        g.putImageData(im, 0, 0);
      } catch (e) {}
    }
    var v = document.createElement('video');
    v.muted = true; v.defaultMuted = true; v.playsInline = true; v.preload = 'auto';
    v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('aria-hidden', 'true');
    v.style.cssText = 'position:absolute;width:1px;height:1px;opacity:0;pointer-events:none';
    v.src = clip;
    var endIm = new Image(), endOk = false, endWant = false;
    endIm.onload = function(){ endOk = true; if (endWant) keyed(endIm); };
    endIm.src = endU;
    function paintEnd(){ endWant = true; if (endOk) keyed(endIm); heroDrawGo(); }
    host.innerHTML = '';
    host.appendChild(cv); host.appendChild(v);
    if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches){ paintEnd(); return true; }
    var live = false, lastT = -1;
    /* AUDIT 10-07: key each VIDEO frame once (the clip is 29.97 fps; rAF at 60 keyed every frame twice). Same pixels. */
    (function frame(){
      if (live && v.readyState >= 2 && v.currentTime !== lastT){ lastT = v.currentTime; keyed(v); if (v.currentTime >= DRAW_CUE) heroDrawGo(); }
      if (!v.ended && !endWant){ if (v.requestVideoFrameCallback && live) v.requestVideoFrameCallback(frame); else requestAnimationFrame(frame); }
    })();
    v.addEventListener('playing', function(){ live = true; });
    v.addEventListener('ended', function(){ live = false; paintEnd(); });
    v.addEventListener('error', paintEnd);
    function go(){
      var pp = v.play && v.play(); if (pp && pp.catch) pp.catch(paintEnd);
      setTimeout(function(){ if (!live) paintEnd(); }, 3000);   /* autoplay refused / slow: never leave a blank hero */
    }
    /* desktop domain clash (pholoh-hero-video.liquid): the logos draw in only once the fight has ended on black */
    var root = document.documentElement;
    if (root.classList.contains('jjk-clash') && !root.classList.contains('jjk-clash-done'))
      document.addEventListener('jjk-clash-done', go, { once: true });
    else go();
    return true;
  }

  /* ---------------------------------------------------------------------------------------
     INLINE SIGN-UP, replacing the CTA button in the hero.

     ⭐ THE EMAIL IS SUBMITTED AT THE END OF STEP 1, NOT AT THE END OF STEP 2.
     This is the whole reason the two steps are split. If the write only happened once the
     phone was filled in, every person who abandons at the phone prompt - which is most of
     them - would be lost completely, and a phone step would cost more addresses than it wins
     numbers. Submitting on step 1 means step 2 is a pure upgrade to a profile that already
     exists, and skipping it costs nothing. Klaviyo merges on email, so the second call
     updates the same profile rather than creating a duplicate.

     Progressive enhancement: the markup this replaces is a real link to
     /pages/assignment-early-access, which still exists and still works. If this script never
     runs, the hero degrades to a button that goes to the full page.

     Phone is skippable BY DESIGN, and the skip is a visible control rather than a hidden one.
     SMS consent must not be a condition of entry - making it one is the pattern that draws
     TCPA complaints - and the disclosure sits under the field where consent is given. */
  var KL_COMPANY = 'SRE64B';    /* public site id - safe in client code, not the private key */
  var KL_LIST    = 'RSUEzd';    /* JJK DROP SIGNUPS (created 2026-10-05) */

  function e164(raw){
    if (!raw) return null;
    var s = String(raw).trim();
    if (s.charAt(0) === '+') {
      var kept = '+' + s.slice(1).replace(/\D/g, '');
      return (kept.length >= 9 && kept.length <= 16) ? kept : null;
    }
    var d = s.replace(/\D/g, '');
    if (d.length === 11 && d.charAt(0) === '1') return '+' + d;
    if (d.length === 10) return '+1' + d;
    return null;
  }

  /* ---------------------------------------------------------------------------------------
     🚨 KNOWN RISK: THIS ENDPOINT CAN ACCEPT A SIGNUP AND THROW IT AWAY.

     Klaviyo's /client/subscriptions/ is fire-and-forget - it answers 202 the moment it takes
     the request and processes it later - so this page CANNOT distinguish a stored signup from
     a discarded one. Measured 2026-09-03: an identical payload created a profile at 17:10,
     then every attempt after ~17:12 returned 202 and created NOTHING (four addresses, one
     never seen before, from both curl and the real browser form) while unrelated live signups
     kept landing normally at 18:17 and 18:18. Read as a throttle on this account after a
     burst of test submissions, not a payload fault - the payload is unchanged from the one
     that worked.

     A Shopify-side fallback was built and REMOVED: POSTing the native customer form to
     /contact returns 400 here for every shape tried (FormData and urlencoded, with and
     without utf8/tags), and this theme renders no newsletter form on the homepage to copy.
     Gating success on it made the hero fail for everyone, including people whose Klaviyo
     write had probably succeeded - strictly worse than the risk it was meant to cover.

     If signups ever need to be guaranteed, the real fix is a server-side endpoint that writes
     with the PRIVATE key and returns a genuine result - not another fire-and-forget call. */
  /* revision 2025-01-15 is load-bearing: on 2024-10-15 this endpoint rejects the per-channel
     `subscriptions` block with a 400 and every signup silently fails. */
  function klaviyo(email, phone){
    var attrs = { email: email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } };
    if (phone) {
      attrs.phone_number = phone;
      attrs.subscriptions.sms = { marketing: { consent: 'SUBSCRIBED' } };
    }
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(KL_COMPANY), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2025-01-15' },
      body: JSON.stringify({ data: { type: 'subscription',
        attributes: { custom_source: 'JJK Hero', profile: { data: { type: 'profile', attributes: attrs } } },
        relationships: { list: { data: { type: 'list', id: KL_LIST } } } } })
    }).then(function(r){
      if (r.status === 202 || r.ok) return true;
      return r.text().then(function(t){ throw new Error(t || ('HTTP ' + r.status)); });
    });
  }


  /* ---- drop countdown ---------------------------------------------------------------------
     Same target as the lock page: Saturday 2026-09-12, 12:00 noon Pacific. September is PDT,
     so the offset is -07:00 - writing -08:00 would put the drop an hour late.

     A days column appears only while it is needed. The Resident Evil build showed raw hours and
     rendered "305:37:09" twelve days out, which nobody reads as a date. Inside the last day it
     drops to HH:MM:SS. When the clock runs out the line says the drop is live rather than
     sitting at zero, so a stale page never claims there is still time. */
  var DROP_ISO = '2026-10-10T12:00:00-07:00';   /* Sat Oct 10 2026, 12:00 noon PDT */

  function startCountdown(el){
    if (!el) return;
    var target = new Date(DROP_ISO).getTime();
    if (!target) return;
    function two(n){ return (n < 10 ? '0' : '') + n; }
    function tick(){
      var ms = target - Date.now();
      if (ms <= 0) { el.textContent = 'OUT NOW'; return; }
      var s = Math.floor(ms / 1000);
      var d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600),
          m = Math.floor(s % 3600 / 60), sec = s % 60;
      el.textContent = (d > 0 ? d + 'd ' : '') + two(h) + ':' + two(m) + ':' + two(sec);
      setTimeout(tick, 1000 - (Date.now() % 1000));
    }
    tick();
  }

  function buildSignup(){
    var slide = document.querySelector('.slideshow__slide');
    var link = (slide && slide.querySelector('.hero__link')) || document.querySelector('.hero__link');
    if (!link || link.querySelector('[data-ats]')) return;

    var wrap = document.createElement('div');
    wrap.className = 'ats';
    wrap.setAttribute('data-ats', '');
    wrap.innerHTML =
      '<form class="ats__row" data-ats-step="email" novalidate>' +
        '<input class="ats__in" type="email" name="email" required autocomplete="email" ' +
               'inputmode="email" placeholder="Your email" aria-label="Your email">' +
        '<button class="ats__go" type="submit">JOIN</button>' +
      '</form>' +
      '<form class="ats__row" data-ats-step="phone" hidden novalidate>' +
        '<input class="ats__in" type="tel" name="phone" autocomplete="tel" inputmode="tel" ' +
               'placeholder="Your phone number" aria-label="Your phone number" required>' +
        '<button class="ats__go" type="submit">DONE</button>' +
      '</form>' +
      '<p class="ats__msg" data-ats-msg role="status" aria-live="polite"></p>' +
      '<p class="ats__fine" data-ats-fine hidden>By entering your number you agree to receive ' +
        'drop alerts by text.<br>' +
        'Recurring automated marketing texts. Consent is not a condition of purchase. ' +
        'Msg &amp; data rates may apply. Reply STOP to opt out.</p>';

    link.innerHTML = '';
    link.appendChild(wrap);

    /* 🚨 KILL THE WHOLE-SLIDE LINK.
       The theme lays an invisible <a class="hero__slide-link"> across the ENTIRE slide at
       z-index 5, so the whole hero acts as one big link to the CTA target. With a button that
       was harmless. With a form it is fatal: elementFromPoint at the centre of the email field
       returned A.hero__slide-link, so tapping the field navigated away instead of focusing it.
       Raising the form alone is not enough either - a mis-tap a few pixels beside the input
       would still leave the page. There is nowhere left for that link to usefully go, because
       the hero's action IS the form now, so it is removed rather than merely covered.
       Scoped to this slide so any other slideshow on the site keeps its own behaviour. */
    var slide = (link.closest && link.closest('.slideshow__slide')) || null;
    var overlays = (slide || document).querySelectorAll('.hero__slide-link');
    for (var i = 0; i < overlays.length; i++) {
      overlays[i].style.setProperty('display', 'none', 'important');
      overlays[i].style.setProperty('pointer-events', 'none', 'important');
    }

    var fEmail = wrap.querySelector('[data-ats-step="email"]');
    var fPhone = wrap.querySelector('[data-ats-step="phone"]');
    var msg    = wrap.querySelector('[data-ats-msg]');
    var fine   = wrap.querySelector('[data-ats-fine]');
    var email  = '';

    function say(t, cls){ msg.textContent = t || ''; msg.className = 'ats__msg ' + (cls || ''); }
    function done(withPhone){
      fEmail.hidden = true; fPhone.hidden = true; fine.hidden = true;
      say(withPhone ? "You're in. Watch your inbox and your texts." : "You're in. Watch your inbox.", 'is-ok');
    }

    fEmail.addEventListener('submit', function(e){
      e.preventDefault();
      var el = fEmail.querySelector('input');
      var v = (el.value || '').trim();
      if (!v || v.indexOf('@') < 1 || v.indexOf('.', v.indexOf('@')) < 0) {
        el.setAttribute('aria-invalid', 'true'); say('Enter a valid email.', 'is-err'); el.focus(); return;
      }
      el.removeAttribute('aria-invalid');
      var btn = fEmail.querySelector('button'); btn.disabled = true; say('One second...', '');
      klaviyo(v, null).then(function(){
        email = v;
        /* Captured and durable. Everything after this point is optional. */
        fEmail.hidden = true; fPhone.hidden = false; fine.hidden = false;
        say('Last step: your phone number for early access.', '');
        fPhone.querySelector('input').focus();
      }).catch(function(err){
        btn.disabled = false; say('Something went wrong. Try again.', 'is-err');
        if (window.console) console.warn('[jjk-signup]', err && err.message);
      });
    });

    fPhone.addEventListener('submit', function(e){
      e.preventDefault();
      var el = fPhone.querySelector('input');
      var raw = (el.value || '').trim();
      if (!raw) { el.setAttribute('aria-invalid', 'true'); say('Enter your phone number to finish.', 'is-err'); el.focus(); return; }
      var p = e164(raw);
      if (!p) {
        el.setAttribute('aria-invalid', 'true');
        say('That number does not look right.', 'is-err'); el.focus(); return;
      }
      el.removeAttribute('aria-invalid');
      var btn = fPhone.querySelector('button'); btn.disabled = true; say('One second...', '');
      /* The email was already saved at step 1, so a phone failure must never read as a
         failed signup. */
      klaviyo(email, p).then(function(){ done(true); }).catch(function(){ done(false); });
    });

    /* no skip: phone is required for JJK (Diego 2026-10-05) */
  }

  function init(){
    injectCss();
    /* JJK (2026-10-05): the City Hall footage has bright daylight shots, so the white furniture needs its own
       ground: a soft radial shade behind lockup + countdown + form (memory: 'the fix is a soft scrim, not black
       ink'), and a smaller desktop lockup so it stops covering the four figures. */
    /* 🎬 film-logo handover (Diego 10-05): from frame 709 (FIN0+110, 23.66s) the film draws its own crayon lockup where
       the site lockup sits; cut the static one out then (cut, not fade - taste rule) and bring it back when the loop
       restarts. rAF, not timeupdate (~250ms granularity would read as a late cut). */
    (function(){
      var T_LOGO = 489 / (30000 / 1001);   /* v2 pace (19.5s, Diego 'a little bit slower'): crayon starts at out-frame 489 (source 709) */
      /* AUDIT 10-07: this rAF used to run 60x a second on EVERY page forever (Lighthouse: the #1 CPU cost site-wide).
         Now it only runs while the hero film is actually playing, and only touches the DOM when the state flips. */
      var running = false, on = null, bound = null;
      function loop(){
        var v = bound;
        if (!v || v.paused || v.ended || !document.body){ running = false; return; }
        var want = v.currentTime >= T_LOGO;
        if (want !== on){ on = want; document.body.classList.toggle('jjk-film-logo', want); }
        requestAnimationFrame(loop);
      }
      function start(){ if (!running){ running = true; requestAnimationFrame(loop); } }
      function stop(){ if (on){ on = false; document.body.classList.remove('jjk-film-logo'); } }
      function bind(){
        var v = document.querySelector('.pholoh-hero-vid');
        if (!v || v === bound) return !!v;
        bound = v;
        v.addEventListener('play', start); v.addEventListener('playing', start);
        v.addEventListener('pause', stop); v.addEventListener('ended', stop);
        if (!v.paused) start();
        return true;
      }
      /* the video is injected by this file later, so look for it a few times, then give up (pages without a hero) */
      var tries = 0; (function look(){ if (!bind() && ++tries < 20) setTimeout(look, 500); })();
    })();
    /* the page colour the hero fades into and the stuck header takes: measured, white or black */
    var PAGE_RGB = (function(){ try { var m = /rgba?\((\d+),\s*(\d+),\s*(\d+)/.exec(getComputedStyle(document.body).backgroundColor || '');
      return m ? m[1] + ',' + m[2] + ',' + m[3] : '0,0,0'; } catch(e){ return '0,0,0'; } })();
    if (!document.getElementById('jjk-extra-css')){
      var jx = document.createElement('style'); jx.id = 'jjk-extra-css';
      jx.textContent =
        '.template-index .pholoh-hero-feather::after{content:"";position:absolute;inset:0;pointer-events:none;z-index:2;' +
          'background:radial-gradient(ellipse 52% 46% at 50% 58%,rgba(0,0,0,.46) 0%,rgba(0,0,0,.30) 45%,rgba(0,0,0,0) 78%)}' +
        '@media (max-width:768px){.template-index .pholoh-hero-feather::after{' +
          'background:radial-gradient(ellipse 80% 42% at 50% 45%,rgba(0,0,0,.44) 0%,rgba(0,0,0,.28) 50%,rgba(0,0,0,0) 82%)}}' +
        '@media (min-width:769px){.template-index .at-lockup{width:min(32vw,470px)!important}}' +
        /* Diego 2026-10-05: NO faded borders - the film covers the whole screen edge to edge and runs up
           UNDER the header (logo, hamburger, account/search/cart sit on the footage); it fades into the white
           page only at the BOTTOM. Header turns white again once it sticks on scroll. */
        /* JJK DARK DRAFT 2026-10-06 (Diego: "the video transitions to the black background flawlessly"): the fade
           takes the PAGE colour, measured, so the same file fades to white on the white theme and to black here.
           Longer, eased ramp on black: a short one reads as a hard band against #000. */
        (PAGE_RGB === '255,255,255'
          ? 'html body.template-index .slideshow__slide::before{background:linear-gradient(to bottom,' +
            'rgba(255,255,255,0) 0,rgba(255,255,255,0) 72%,rgba(255,255,255,.14) 80%,rgba(255,255,255,.5) 88%,' +
            'rgba(255,255,255,.86) 95%,#fff 100%)!important}'
          : 'html body.template-index .slideshow__slide::before{content:"";position:absolute;inset:0;z-index:2;pointer-events:none;' +
            'opacity:1!important;display:block!important;background:linear-gradient(to bottom,' +
            'rgba(' + PAGE_RGB + ',0) 0,rgba(' + PAGE_RGB + ',0) 58%,rgba(' + PAGE_RGB + ',.10) 66%,rgba(' + PAGE_RGB + ',.32) 74%,' +
            'rgba(' + PAGE_RGB + ',.62) 83%,rgba(' + PAGE_RGB + ',.88) 92%,rgb(' + PAGE_RGB + ') 100%)!important}') +
        ':root[data-theme] body.template-index #SiteHeader.site-header:not(.site-header--stuck),html body.template-index #SiteHeader:not(.site-header--stuck),' +
          'html body.template-index .header-wrapper:not(.header-wrapper--stuck){background:transparent!important;' +
          'background-image:none!important;border-bottom:0!important;box-shadow:none!important}' +
        ':root[data-theme] body.template-index #SiteHeader.site-header.site-header--stuck{background:rgb(' + PAGE_RGB + ')!important;' +
          'backdrop-filter:none!important;box-shadow:none!important}' +
        /* black header ink -> white over the film with a soft shadow; invert() so the inline !important
           colours inkHeader() sets (and the black logo PNG) flip without fighting them */
        'html body.template-index #SiteHeader:not(.site-header--stuck) .site-header__logo img,' +
          'html body.template-index #SiteHeader:not(.site-header--stuck) .header-item--icons,' +
          'html body.template-index #SiteHeader:not(.site-header--stuck) .header-item--navigation{' +
          'filter:invert(1) drop-shadow(0 1px 3px rgba(0,0,0,.55))!important}' +
        ':root[data-theme] body.template-index #SiteHeader.site-header:not(.site-header--stuck) .site-header__logo img{' +
          'filter:brightness(0) invert(1) drop-shadow(0 1px 3px rgba(0,0,0,.55))!important}' +
        ':root[data-theme] body.template-index #SiteHeader.site-header:not(.site-header--stuck) .header-item--icons img,:root[data-theme] body.template-index #SiteHeader.site-header:not(.site-header--stuck) .header-item--icons .currency-flag{filter:invert(1)!important}' +
        /* a light shade at the very top so the white header ink reads on bright skies */
        /* 2:3 mobile cut (jjk-hero-m23.mp4) fills the 2:3 phone hero exactly: no crop, no offset */
        '@media (max-width:768px){html body.template-index .pholoh-hero-vid,html body.template-index .slideshow__slide img.hero__image{' +
          'object-position:50% 50%!important}}' +
        /* the film draws its own crayon JJK x PHOLOH lockup at the end, in the same band: the static one cuts out */
        'html body.jjk-film-logo.template-index .at-lockup{visibility:hidden!important}' +
        'html body.template-index .slideshow__slide::after{content:"";position:absolute;left:0;right:0;top:0;height:24%;' +
          'pointer-events:none;z-index:3;opacity:1!important;' +
          'background:linear-gradient(to bottom,rgba(0,0,0,.42) 0,rgba(0,0,0,.18) 50%,rgba(0,0,0,0) 100%)!important}';
      document.head.appendChild(jx);
    }
    inkHeader();
    if (document.body && document.body.className.indexOf('template-index') === -1) return;
    swapLockup();

    /* Match the subtitle by POSITION (first subtitle in the first slide), never by its text,
       so editing the subheading setting cannot break this. */
    var slide = document.querySelector('.slideshow__slide');
    var sub = (slide && slide.querySelector('.hero__subtitle')) || document.querySelector('.hero__subtitle');
    if (!sub) return;
    var contents = sub.querySelector('.animation-contents') || sub;
    var txt = (contents.textContent || '').replace(/\s+/g, ' ').trim() || 'GET EARLY ACCESS';
    /* 13px, not the RE build's 11px: this line is no longer a status caption, it is the label
       for the field directly underneath it, so it has to carry that job. */
    /* ⭐ THE LIGHT BUILD IS THE POST-DROP HOMEPAGE: no countdown, no email capture, just two
       ways into the product. The dark build is still pre-launch and keeps the capture. */
    if (LIGHT && Date.now() >= new Date(DROP_ISO).getTime()){   /* post-drop only */
      /* 🚨 PUT THE BUTTONS WHERE THE FORM WENT, NOT WHERE THE SUBTITLE IS. Writing them into the
         subtitle put them at the very top of the hero, tucked under the sticky header - the
         subtitle is not the block that sits in the middle of the slide. `.hero__link` is the
         container the signup used and it is the one that lands centred. */
      contents.innerHTML = '';
      var slideL = document.querySelector('.slideshow__slide');
      var host = (slideL && slideL.querySelector('.hero__link')) || document.querySelector('.hero__link') || contents;
      host.innerHTML =
        '<div class="athero-cta">' +
          /* clipPath in userSpaceOnUse at the same 104x104 the element is sized to, so the glyph
             lands exactly on the box. Its five children UNION, which is what makes the beam,
             both stems and both note heads read as one solid silhouette. */
          '<svg class="athero-noteclip-host" aria-hidden="true" focusable="false">' +
            '<defs><clipPath id="athero-noteclip" clipPathUnits="userSpaceOnUse">' +
              '<path d="M39 9 L101 0 L101 19 L39 28 Z"/>' +
              '<rect x="34" y="19" width="8" height="66" rx="2.8"/>' +
              '<rect x="93" y="11" width="8" height="54" rx="2.8"/>' +
              '<ellipse cx="19" cy="88" rx="18.8" ry="14" transform="rotate(-19 19 88)"/>' +
              '<ellipse cx="78" cy="68" rx="18.8" ry="14" transform="rotate(-19 78 68)"/>' +
            '</clipPath></defs>' +
          '</svg>' +
          '<a class="athero-note-btn" href="/collections/kosen" aria-label="Live now - shop the drop">' +
            '<span class="athero-note-wrap"><span class="athero-note"></span></span>' +
            '<span class="athero-dot__lbl">Live now</span>' +
          '</a>' +
        '</div>';
      /* 🚨 The theme lays an invisible <a class="hero__slide-link"> across the WHOLE slide at
         z-index 5. With two real buttons underneath it, every tap would hit that overlay and go
         wherever the slide's CTA points instead of where the button says. Remove it, scoped to
         this slide so any other slideshow keeps its behaviour. */
      var sl = document.querySelector('.slideshow__slide') || document;
      var ov = sl.querySelectorAll('.hero__slide-link');
      for (var oi = 0; oi < ov.length; oi++){
        ov[oi].style.setProperty('display', 'none', 'important');
        ov[oi].style.setProperty('pointer-events', 'none', 'important');
      }
      return;
    }

    /* Diego 10-06: under the logos, the anime's own JUJUTSU KAISEN wordmark (red, assets/jjk-title-red.svg, Wikimedia
       public-domain vector) INSTEAD of "Get early access" + the timer + the sign-up form. Those functions stay defined above. */
    void txt; void startCountdown; void buildSignup;
    /* Diego 10-07: both DRAW IN after the logos (class jjk-draw-go on <html>, set by drawLockup at DRAW_CUE). The title is
       jjk-title-draw.svg = the same wordmark split into one path per letter (title/split_title.py), traced then filled, left to
       right; the ring is the --jjk-ring crayon ellipse as live paths so it can be traced, then LIVE NOW wipes in. */
    contents.innerHTML = '<div class="jjk-title-host" aria-label="Jujutsu Kaisen" role="img"></div>'
      /* Diego 10-06: a circled LIVE NOW button right under the name -> the JJK collection */
      + '<a class="jjk-live jjk-live--draw" href="/collections/kosen"><svg class="jjk-live__ring" viewBox="0 0 100 40" preserveAspectRatio="none" aria-hidden="true">'
      + '<path pathLength="1" d="M50 3.5 C80 2.5 97.5 9 97 20 C96.5 31.5 78 37.5 50 37 C21 36.5 2.5 31 3 19.5 C3.5 8.5 22 3.8 54 4.6"/>'
      + '<path pathLength="1" class="r2" d="M52 5.5 C79 5 95 10.5 94.5 20.5 C94 30 77 35 50 35 C24 35 5.5 30 6 20 C6.5 10.5 24 6 47 5.3"/>'
      + '</svg><span>Live now</span></a>';
    var th = contents.querySelector('.jjk-title-host');
    function titleImg(){ th.innerHTML = '<img class="jjk-title" src="' + assetUrl('jjk-title-red.svg') + '" alt="Jujutsu Kaisen" width="1260" height="278">'; }
    if (window.fetch) fetch(assetUrl('jjk-title-draw.svg')).then(function(r){ if (!r.ok) throw 0; return r.text(); })
      .then(function(t){ th.innerHTML = t; }).catch(titleImg);
    else titleImg();
    if (!document.querySelector('.at-lockup--draw')) heroDrawGo();   /* no draw clip -> show everything at once */
    var lnk = (slide && slide.querySelector('.hero__link')) || document.querySelector('.hero__link');
    if (lnk) lnk.style.setProperty('display', 'none', 'important');
    /* the theme's invisible whole-slide link (z-index 5) would swallow the LIVE NOW tap - remove it, as buildSignup used to */
    var ovs = (slide || document).querySelectorAll('.hero__slide-link');
    for (var q = 0; q < ovs.length; q++) { ovs[q].style.setProperty('display', 'none', 'important'); ovs[q].style.setProperty('pointer-events', 'none', 'important'); }
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
